import { DriveEta, LocalMall } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { selectOrderType } from 'redux/cart/cart.selectors';

export const useGetOrderTypeIcon = () => {
  const orderType = useSelector(selectOrderType);

  return orderType === 'PICKUP' ? LocalMall : DriveEta;
};
